export default [
  {
    path: "/moedas",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "moedas_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Moedas", to: "moedas_list" }],
          permission: "moeda:view",
          title: "Moedas"
        }
      },
      {
        name: "moedas_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Moedas", to: "moedas_list" }],
          permission: "moeda:create",
          title: "Moedas - Cadastro"
        }
      },
      {
        name: "moedas_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Moedas", to: "moedas_list" }],
          permission: "moeda:edit",
          title: "Moedas - Edição"
        }
      }
    ]
  }
];
